var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrettier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210 210",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0{fill:#56b3b4}.st1{fill:#ea5e5e}.st2{fill:#bf85bf}.st3{fill:#f7ba3e}.st4{opacity:.5;fill:#4d616e;enable-background:new}\n    ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "prettier-icon-dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prettier-icon-dark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-_x28_Dark_x29_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    className: "st0",
    d: "M155 40h10c2.8 0 5 2.2 5 5s-2.2 5-5 5h-10c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_",
    className: "st1",
    d: "M5 200h50c2.8 0 5 2.2 5 5s-2.2 5-5 5H5c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_",
    className: "st2",
    d: "M125 120h30c2.8 0 5 2.2 5 5s-2.2 5-5 5h-30c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3_",
    className: "st1",
    d: "M65 120h40c2.8 0 5 2.2 5 5s-2.2 5-5 5H65c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4_",
    className: "st0",
    d: "M5 120h40c2.8 0 5 2.2 5 5s-2.2 5-5 5H5c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5_",
    className: "st2",
    d: "M5 160h50c2.8 0 5 2.2 5 5s-2.2 5-5 5H5c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6_",
    className: "st2",
    d: "M5 80h50c2.8 0 5 2.2 5 5s-2.2 5-5 5H5c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7_",
    className: "st3",
    d: "M55 20h100c2.8 0 5 2.2 5 5s-2.2 5-5 5H55c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8_",
    className: "st1",
    d: "M5 20h30c2.8 0 5 2.2 5 5s-2.2 5-5 5H5c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9_",
    className: "st3",
    d: "M45 180h10c2.8 0 5 2.2 5 5s-2.2 5-5 5H45c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10_",
    className: "st0",
    d: "M45 60h10c2.8 0 5 2.2 5 5s-2.2 5-5 5H45c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11_",
    className: "st0",
    d: "M5 180h20c2.8 0 5 2.2 5 5s-2.2 5-5 5H5c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12_",
    className: "st3",
    d: "M5 60h20c2.8 0 5 2.2 5 5s-2.2 5-5 5H5c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13_",
    className: "st4",
    d: "M135 180h10c2.8 0 5 2.2 5 5s-2.2 5-5 5h-10c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14_",
    className: "st4",
    d: "M75 180h40c2.8 0 5 2.2 5 5s-2.2 5-5 5H75c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15_",
    className: "st4",
    d: "M165 180h40c2.8 0 5 2.2 5 5s-2.2 5-5 5h-40c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16_",
    className: "st0",
    d: "M85 100h80c2.8 0 5 2.2 5 5s-2.2 5-5 5H85c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17_",
    className: "st3",
    d: "M35 100h30c2.8 0 5 2.2 5 5s-2.2 5-5 5H35c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18_",
    className: "st1",
    d: "M5 100h10c2.8 0 5 2.2 5 5s-2.2 5-5 5H5c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19_",
    className: "st2",
    d: "M95 40h40c2.8 0 5 2.2 5 5s-2.2 5-5 5H95c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_20_",
    className: "st0",
    d: "M5 40h70c2.8 0 5 2.2 5 5s-2.2 5-5 5H5c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_21_",
    className: "st3",
    d: "M35 140h90c2.8 0 5 2.2 5 5s-2.2 5-5 5H35c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22_",
    className: "st2",
    d: "M5 140h10c2.8 0 5 2.2 5 5s-2.2 5-5 5H5c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23_",
    className: "st1",
    d: "M125 60h50c2.8 0 5 2.2 5 5s-2.2 5-5 5h-50c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_24_",
    className: "st3",
    d: "M125 80h50c2.8 0 5 2.2 5 5s-2.2 5-5 5h-50c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25_",
    className: "st0",
    d: "M5 0h120c2.8 0 5 2.2 5 5s-2.2 5-5 5H5c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_26_",
    className: "st4",
    d: "M145 0h60c2.8 0 5 2.2 5 5s-2.2 5-5 5h-60c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_27_",
    className: "st4",
    d: "M145 140h20c2.8 0 5 2.2 5 5s-2.2 5-5 5h-20c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28_",
    className: "st4",
    d: "M185 140h20c2.8 0 5 2.2 5 5s-2.2 5-5 5h-20c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_29_",
    className: "st4",
    d: "M175 120h30c2.8 0 5 2.2 5 5s-2.2 5-5 5h-30c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_30_",
    className: "st4",
    d: "M175 20h30c2.8 0 5 2.2 5 5s-2.2 5-5 5h-30c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_31_",
    className: "st4",
    d: "M185 100h20c2.8 0 5 2.2 5 5s-2.2 5-5 5h-20c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_32_",
    className: "st4",
    d: "M185 40h20c2.8 0 5 2.2 5 5s-2.2 5-5 5h-20c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_33_",
    className: "st4",
    d: "M195 60h10c2.8 0 5 2.2 5 5s-2.2 5-5 5h-10c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_34_",
    className: "st4",
    d: "M195 80h10c2.8 0 5 2.2 5 5s-2.2 5-5 5h-10c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_35_",
    className: "st4",
    d: "M115 160h90c2.8 0 5 2.2 5 5s-2.2 5-5 5h-90c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_36_",
    className: "st4",
    d: "M75 160h20c2.8 0 5 2.2 5 5s-2.2 5-5 5H75c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_37_",
    className: "st4",
    d: "M155 200h50c2.8 0 5 2.2 5 5s-2.2 5-5 5h-50c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_38_",
    className: "st4",
    d: "M75 200h60c2.8 0 5 2.2 5 5s-2.2 5-5 5H75c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_39_",
    className: "st4",
    d: "M75 60h30c2.8 0 5 2.2 5 5s-2.2 5-5 5H75c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_40_",
    className: "st4",
    d: "M75 80h30c2.8 0 5 2.2 5 5s-2.2 5-5 5H75c-2.8 0-5-2.2-5-5s2.2-5 5-5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrettier);
export default __webpack_public_path__ + "static/media/prettier.9c127e31bb7b2809649ee21a5ea73edc.svg";
export { ForwardRef as ReactComponent };